import type { RuleGraphConditionSubject } from "@intelligems/ig-types/dtos/agentic-logic/rule-graph";

export const RULE_GRAPH_CONDITION_PHRASES: Record<
  RuleGraphConditionSubject,
  { when: string; whenAnything: string; fallbackWhen: string }
> = {
  cart: {
    when: "When cart contains",
    whenAnything: "When cart contains anything",
    fallbackWhen: "If nothing matches and cart contains",
  },
  delivery: {
    when: "When delivery is",
    whenAnything: "For any delivery option",
    fallbackWhen: "If nothing matches and delivery is",
  },
  shipping: {
    when: "When shipping is",
    whenAnything: "For any shipping state",
    fallbackWhen: "If nothing matches and shipping is",
  },
  customer: {
    when: "When the shopper has",
    whenAnything: "For any shopper",
    fallbackWhen: "If nothing matches and the shopper has",
  },
  page: {
    when: "When the page is",
    whenAnything: "On any page",
    fallbackWhen: "If nothing matches and the page is",
  },
  order: {
    when: "When the order has",
    whenAnything: "For any order",
    fallbackWhen: "If nothing matches and the order has",
  },
  time: {
    when: "When the time is",
    whenAnything: "At any time",
    fallbackWhen: "If nothing matches and the time is",
  },
};
